import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send, User, MessageSquare, Loader2 } from 'lucide-react';
import { contactData, contactSecondData } from '../mockData';
import Footer from '../components/Footer';
import { useToast } from '../hooks/use-toast';
import axios from "axios";
import Swal from "sweetalert2";

const ContactPage = () => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    projectType: '',
    budget: '',
    location: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Please enter your name";
    if (!formData.phone) {
      newErrors.phone = "Please enter your mobile number";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Mobile number must be 10 digits";
    }
    if (!formData.email) {
      newErrors.email = "Please enter your email address";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!formData.message.trim()) newErrors.message = "Please enter your message";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        mobile: formData.phone,
        message: formData.message,
      };
      console.log("📤 Sending Payload:", payload);

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/madhuprabha/contact-request`,
        payload,
      );

      console.log("📤 API Response:", response.data);


      if (response.data.status === "SUCCESS") {
        Swal.fire({
          title: "Message Sent!",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });


        setFormData({
          name: "",
          email: "",
          phone: "",
          projectType: "",
          budget: "",
          location: "",
          message: "",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.message || "Something went wrong.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("❌ API Error:", error);

      Swal.fire({
        title: "Message Failed!",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };



  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const projectTypes = [
    'Villa Construction',
    'Apartment Building',
    'Duplex Home',
    'Row Houses',
    'Home Renovation',
    'Other'
  ];

  const budgetRanges = [
    '₹20-50 Lakhs',
    '₹50-1 Crore',
    '₹1-2 Crores',
    '₹2-5 Crores',
    '₹5+ Crores',
    'Discuss Later'
  ];

  const contactMethods = [
 {
  icon: Phone,
  title: "Call Us",
  detail: `${contactData.phone1}, ${contactData.phone2}`,
  description: "Speak directly with our team",
  color: "from-[#011321]-500 to-[#011321]",
}

,
    { icon: Mail, title: "Email Us", detail: contactData.email, description: "Send us your requirements", color: "from-['#011321']-500 to-['#011321']" },
    { icon: MapPin, title: "Visit Our Office", detail: contactData.address, description: "Come for a face-to-face meeting", color: "from-['#011321']-500 to-['#011321']" },
    { icon: Clock, title: "Working Hours", detail: contactData.workingHours, description: "We're available during these hours", color: "from-['#011321']-500 to-['#011321']" }
  ];

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <section
        className="relative pt-28 pb-20 text-white overflow-hidden"
        style={{
          backgroundImage: "url('/images/contact-images.jpg')",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: '90vh',
        }}
      >
        {/* White blur lights */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 sm:top-20 right-10 sm:right-20 w-48 sm:w-96 h-48 sm:h-96 bg-white rounded-full blur-2xl"></div>
          <div className="absolute bottom-10 sm:bottom-20 left-10 sm:left-20 w-40 sm:w-64 h-40 sm:h-64 bg-white rounded-full blur-2xl"></div>
        </div>


      </section>

      {/* Contact Methods */}
      <section className="py-20 bg-white mt-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl  font-bold text-gray-900 mb-6 -mt-[20px]">
              Get In Touch

            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Choose your preferred way to contact us. We're here to help with all your construction needs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
            {contactMethods.map((method, index) => {
              const Icon = method.icon;
              return (
                <div key={index} className="group text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-white-300 transition-all duration-300 border border-['#011321'] transform hover:-translate-y-2">
                  <div className={`w-16 h-16 bg-[#011321] ${method.color} rounded-2xl flex items-center justify-center mx-auto mb-6  transition-transform duration-300 shadow-lg`}>
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{method.title}</h3>
                  {/* {method.title === "Call Us" && <a href={`tel:${method.detail}`} className="text-gray-700 font-medium mb-2 hover:text-[#000] transition-colors duration-300">{method.detail}</a>}
                   */}

                   {method.title === "Call Us" && (
  <div className="flex flex-col space-y-1">
    {method.detail.split(',').map((num, index) => (
      <a
        key={index}
        href={`tel:${num.trim()}`}
        className="text-gray-700 font-medium hover:text-[#000] transition-colors duration-300"
      >
        {num.trim()}
      </a>
    ))}
  </div>
)}

                  {method.title === "Email Us" && <a href={`mailto:${method.detail}`} className="text-gray-700 font-medium mb-2  transition-colors duration-300 break-words text-sm">{method.detail}</a>}
                  {method.title === "Visit Our Office" && <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(method.detail)}`} target="_blank" rel="noopener noreferrer" className="text-gray-700 font-medium mb-2 hover:text-[#011321] transition-colors duration-300">{method.detail}</a>}
                  {method.title === "Working Hours" && <p className="text-gray-700 font-medium mb-2">{method.detail}</p>}
                  <p className="text-sm text-gray-500">{method.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact Form & Map */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-[200px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            <div className="bg-white text-[#011321] border border-['#011321'] rounded-2xl shadow-lg p-8 sm:p-10">
              <h3 className="text-3xl font-bold text-gray-900 mb-8">
                Send Us a{" "}
                <span className="text-[#011321]">
                  Message
                </span>
              </h3>

              <form onSubmit={handleSubmit} className="space-y-6">

                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Full Name *
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={(e) => {
                        // Sirf letters aur space allow kare
                        const onlyText = e.target.value.replace(/[^A-Za-z\s]/g, "");
                        handleChange({ target: { name: "name", value: onlyText } });
                      }}
                      className="w-full pl-3 pr-4 py-3 border border-[#011321] rounded-xl focus:ring-2 focus:ring-[#011321] focus:border-transparent outline-none transition-all duration-300"
                      placeholder="Your Name"
                    />
                    {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
                  </div>
                </div>


                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number *
                  </label>
                  <div className="relative">

                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => {
                        // Sirf numbers allow karo aur max 10 digit rakho
                        const value = e.target.value.replace(/\D/g, "");
                        if (value.length <= 10) {
                          setFormData((prev) => ({
                            ...prev,
                            phone: value,
                          }));
                        }
                      }}
                      maxLength="10"
                      pattern="[0-9]{10}"
                      className="w-full pl-3 pr-4 py-3 border border-[#011321] rounded-xl 
                       focus:ring-2 focus:ring-[#011321] focus:border-transparent 
                       outline-none transition-all duration-300"
                      placeholder="9876543210"
                    />
                    {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">Enter 10 digit mobile number only</p>
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <div className="relative">

                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full pl-3 pr-4 py-3 border border-[#011321] rounded-xl focus:ring-2 focus:ring-[#011321] focus:border-transparent outline-none transition-all duration-300"
                      placeholder="your@email.com"
                    />

                  </div>
                  {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Message *
                  </label>
                  <div className="relative">
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full pl-3 pr-4 py-3 border border-[#011321] rounded-xl focus:ring-2 focus:ring-[#011321] focus:border-transparent outline-none transition-all duration-300 resize-none"
                      placeholder="Tell us about your project requirements, timeline, and any specific needs..."
                    ></textarea>
                    {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="group w-full flex items-center justify-center space-x-3 py-4 px-6 
          bg-white text-[#011321] font-semibold rounded-xl border border-[#011321] 
          hover:bg-[#011321] hover:text-white transition-colors duration-300
          disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <>
                      <Loader2 className="w-5 h-5 animate-spin text-[#011321] group-hover:text-white" />

                      <span>Sending...</span>
                    </>
                  ) : (
                    <>
                      <Send className="w-5 h-5 text-[#011321] group-hover:text-white group-hover:translate-x-1 transition-transform duration-300" />
                      <span>Send Message</span>
                    </>
                  )}
                </button>

              </form>
            </div>

            {/* Map and Office Info */}
            <div className="space-y-8">
              {/* Office Map */}
              <div className="relative bg-white rounded-2xl overflow-hidden shadow-xl h-96">
                <iframe
                  title="office-location"
                  src="https://www.google.com/maps?q=UMA+Apartment,+Behind+Binzani+Book+Depot,+Tilak+Road,+Mahal,+Nagpur-2&output=embed"
                  className="absolute inset-0 w-full h-full border-0"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>

                <div className="absolute inset-0 bg-gradient-to-br from-red-100/20 to-white/20 pointer-events-none"></div>

                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <div className="w-6 h-6 bg-red-500 rounded-full border-4 border-white shadow-lg animate-ping"></div>
                  <div className="w-6 h-6 bg-red-500 rounded-full border-4 border-white shadow-lg absolute top-0 left-0"></div>
                </div>
              </div>

              {/* Office Details Card */}
              <div className="bg-white text-[#011321] rounded-2xl p-8 shadow-xl border border-['#011321']">
                <h4 className="text-2xl font-bold mb-6">Visit Our Office</h4>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <MapPin className="w-6 h-6 mt-1 text-[#011321] flex-shrink-0" />
                    <div>
                      <p className="font-medium text-[#011321]">Head Office Address</p>
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contactData.address)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-[#011321] hover:text-[#011321] transition-colors duration-300"
                      >
                        {contactData.address}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <MapPin className="w-6 h-6 mt-1 text-[#011321] flex-shrink-0" />
                    <div>
                      <p className="font-medium text-[#011321]">Branch Office Address</p>
                      <a
                        // href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contactData.address)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-[#011321] hover:text-[#011321] transition-colors duration-300"
                      >
                        {contactSecondData.address}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Clock className="w-6 h-6 mt-1 text-[#011321] flex-shrink-0" />
                    <div>
                      <p className="font-medium text-[#011321]">Office Hours</p>
                      <p className="text-sm text-[#011321]">{contactData.workingHours}</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Phone className="w-6 h-6 mt-1 text-[#011321] flex-shrink-0" />
                    <div>
                      <p className="font-medium text-[#011321]">Phone</p>
                      <a
                        href={`tel:${contactData.phone1}`}
                        className="text-sm text-[#011321] hover:text-[#011321] transition-colors duration-300"
                      >
                        {contactData.phone1}
                      </a>,
                      <a
                        href={`tel:${contactData.phone2}`}
                        className="text-sm text-[#011321] hover:text-[#011321] transition-colors duration-300"
                      >
                        {contactData.phone2}
                      </a>
                    </div>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-[#011321]">
                  <p className="text-sm text-[#011321]">
                    <strong>Note:</strong> We recommend scheduling an appointment for personalized consultation and site visit discussions.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;